<template>
	<div>
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div>
			<v-text-field
				data-lpignore="true"
				:ref="fieldRef"
				class="widget-input-field"
				v-model="value"
				v-bind="activeFormFieldCommonProps"
				prefix="@"
				:placeholder="placeholder"
			>
			</v-text-field>
		</div>
	</div>
</template>

<script>
import WidgetFieldMixin from './WidgetFieldMixin';
import DefaultWidgetField from './DefaultWidgetField';
import { DataTypeEvaluator, toEmail } from '@ply-io/data-types';
const evaluator = new DataTypeEvaluator();
export default {
	name: 'EmailInputField',
	components: {
		DefaultWidgetField,
	},
	mixins: [WidgetFieldMixin],
	props: {},
	computed: {
		placeholder() {
			if (!this.field.metadata.options.placeholder.enabled) {
				return '';
			}
			return this.field.metadata.options.placeholder.value;
		},
		fieldOutput() {
			return this.fieldMetadata.output;
		},
		fieldValidations() {
			return this.fieldMetadata.validations;
		},
		emailValidator() {
			return this.fieldValidations.email;
		},
		emailFormatValidator() {
			return this.fieldValidations.format;
		},
		hostValidator() {
			return this.fieldValidations.host;
		},
		customFieldValidation() {
			const rules = [];
			if (!this.field.metadata.options.required.enabled && this.value === '') {
				return [];
			}
			if (this.emailValidator.enabled) {
				rules.push((v) => {
					if (evaluator.isEmail(v)) {
						return true;
					} else {
						return `Must be a valid email`;
					}
				});
			}
			if (this.emailFormatValidator.enabled) {
				rules.push((v) => {
					if (this.emailFormatValidator.value) {
						const re = new RegExp(this.emailFormatValidator.value);
						if (re.test(v)) {
							return true;
						} else {
							return `Must be email formatted like this: ${this.emailFormatValidator.value}`;
						}
					}
					return true;
				});
			}
			if (this.hostValidator.enabled) {
				rules.push((v) => {
					if (this.hostValidator.value) {
						const email = toEmail(v);
						if (email && email.domain?.toLowerCase() === this.hostValidator.value?.toLowerCase()) {
							return true;
						} else {
							return `Must be ${this.hostValidator.value} email`;
						}
					}
					return true;
				});
			}
			return rules;
		},
	},
};
</script>

<style scoped lang="scss">
.widget-input-field {
	::v-deep(.v-text-field__prefix) {
		padding-bottom: 4px !important;
	}
}
</style>
